const RestrictedInput = require("components/forms/RestrictedInput");
const assign = require("object-assign");

class IntegerField extends RestrictedInput {

	normalize(value) {
		return super.normalize(value.replace(/[^0-9]/g, ""));
	}

	get className() {
		let classList = ["integer-field"];

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	get inputProps() {
		return assign(super.inputProps, {type: "text", pattern: "[0-9]*", className: this.className});
	}

}

module.exports = IntegerField;


// WEBPACK FOOTER //
// ./resources/js/components/forms/IntegerField.js